import $ from 'jquery';

$(document).ready(function() {
  var wpcf7Form = $('.wpcf7')[0];

  if ($(wpcf7Form).length) {
    if ($('body').find('.digest')) {
      const preloader = $('.digest').find('.preloader');

      wpcf7Form.addEventListener('submit', function() {
        preloader.addClass('done');
        setTimeout(() => {
          preloader.removeClass('done');
        }, 2000);
      });

      wpcf7Form.addEventListener('wpcf7mailsent', function() {
        $('#thxFollow-window').addClass('active');

        if ($('#thxFollow-window').hasClass('active')) {
          $.fancybox.open({
            src: '#thxFollow-window',
            closeExisting: true,
            smallBtn: false,
            toolbar: false,
            touch: false
          });
        }
      });
    }

    if ($('body').hasClass('authors-page')) {
      wpcf7Form.addEventListener('wpcf7mailsent', function() {
        let preloader = $('.authors').find('.preloader');
        preloader.addClass('done');
        $('#comeAuthorThx-window').addClass('active');
        $.fancybox.open({
          src: '#comeAuthorThx-window',
          closeExisting: true,
          smallBtn: false,
          toolbar: false,
          touch: false
        });
        preloader.removeClass('done');
      });
    }
    if ($('body').hasClass('author-page')) {
      wpcf7Form.addEventListener('wpcf7mailsent', function() {
        let preloader = $('.author').find('.preloader');
        preloader.addClass('done');
        $('#comeAuthorThx-window').addClass('active');
        $.fancybox.open({
          src: '#comeAuthorThx-window',
          closeExisting: true,
          smallBtn: false,
          toolbar: false,
          touch: false
        });
        preloader.removeClass('done');
      });
    }
  }
});
